// extracted by mini-css-extract-plugin
module.exports = {"header":"ShipmentList_header__3VBIn","title":"ShipmentList_title__2vC3e","small":"ShipmentList_small__2LwgJ","btnContainer":"ShipmentList_btnContainer__PjSoC"};